'use client'

import { Box, Card, CardContent, Stack, Typography } from '@mui/material'

import { useReportLostDevice } from '../model/useReportLostDevice'
import { EmailStep } from './EmailStep'
import { OtpStep } from './OtpStep'
import { DoneStep } from './DoneStep'

export function ReportLostDevicePage() {
  const { step, error, email, emailForm, otpForm, sendCode, confirm, resend } = useReportLostDevice()

  return (
    <Box display="flex" justifyContent="center" alignItems="flex-start" sx={{ p: 3 }}>
      <Card sx={{ maxWidth: 480, width: '100%', mt: 6 }}>
        <CardContent>
          <Stack spacing={3}>
            <Box>
              <Typography variant="h5" gutterBottom>
                Signaler la perte ou le vol d'un appareil
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Si vous avez perdu ou vous êtes fait voler l'appareil qui vous sert à vous connecter, désactivez son accès ici. Toute connexion sera ensuite
                refusée jusqu'à ce que votre établissement réactive votre compte.
              </Typography>
            </Box>

            {step === 'email' && <EmailStep form={emailForm} onSubmit={sendCode} error={error} />}
            {step === 'otp' && <OtpStep form={otpForm} email={email} onSubmit={confirm} onResend={resend} error={error} />}
            {step === 'done' && <DoneStep />}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}
